import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import Aos from "aos";
import "aos/dist/aos.css";
import { Customization, Modern, Update, Visual } from "../../svg";
// const Data{

// }
const Service = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <>
      <div id="Service">
        <div className="container">
          <Row>
            <Col xl={3} lg={3} md={3} sm={6}>
              <div className="service-box">
                <Modern />
                <h2 className="f-25 fw-700 m-20-0 m-5-0-15-0 lh-35">
                  Modern<br />
                  Minimal Design
                </h2>
                <p className="main-gray-text f-16 lh-25 ">
                  It is a long established fact that a reader will be distracted by the readable content of a page.
                </p>
              </div>
            </Col>
            <Col xl={3} lg={3} md={3} sm={6}>
              <div className="service-box">
                <Customization />
                <h2 className="f-25 fw-700 m-20-0 m-5-0-15-0 lh-35">
                  Easy<br />
                  Customization
                </h2>
                <p className="main-gray-text f-16 lh-25 ">
                  It is a long established fact that a reader will be distracted by the readable content of a page.
                </p>
              </div>
            </Col>
            <Col xl={3} lg={3} md={3} sm={6}>
              <div className="service-box">
                <Visual />
                <h2 className="f-25 fw-700 m-20-0 m-5-0-15-0 lh-35">
                  Visual<br />
                  Page Builder
                </h2>
                <p className="main-gray-text f-16 lh-25 ">
                  It is a long established fact that a reader will be distracted by the readable content of a page.
                </p>
              </div>
            </Col>
            <Col xl={3} lg={3} md={3} sm={6}>
              <div className="service-box">
                <Update />
                <h2 className="f-25 fw-700 m-20-0 m-5-0-15-0 lh-35">
                  Free<br />
                  Lifetime Update
                </h2>
                <p className="main-gray-text f-16 lh-25 ">
                  It is a long established fact that a reader will be distracted by the readable content of a page.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default Service;
